export const AUTH = '/auth'
export const AUTH_GOOGLE_SSO = '/auth/login/google-sso'
export const UNAUTHENTICATED_USERS = '/users'

const requestMagicLink = (): string => `${AUTH}/send-magic-link`

const requestOtpEnpoint = `${AUTH}/send-email-otp`

const verifyOtpEnpoint = `${AUTH}/verify-email-otp`

const authenticateWithMagicLink = (token: string, dob?: string): string =>
  `${AUTH}/login/${token}${dob ? `?dob=${dob}` : ''}`

const verifyTokenExpirationLink = (token: string): string =>
  `${AUTH}/verify-token/${token}`

export const AuthRoutes = {
  requestMagicLink,
  requestOtpEnpoint,
  verifyOtpEnpoint,
  authenticateWithMagicLink,
  verifyTokenExpirationLink,
}
